import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../../_metronic/assets/ts/_utils";

const baseColor = getCSSVariableValue("--bs-primary");

TopBarProgress.config({
  barColors: {
    "0": baseColor,
  },
  barThickness: 5,
  shadowBlur: 5,
});

const TopBarLoader = () => <TopBarProgress />;

export default TopBarLoader;
